"use strict";

exports.__esModule = true;
exports.PersistentState = exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = void 0;
var _persistentState = require("./persistentState");
exports.PLUGIN_KEY = _persistentState.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _persistentState.PLUGIN_PRIORITY;
exports.PersistentState = _persistentState.PersistentState;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/persistentState/index.js
// module id = 1539
// module chunks = 0